import React from 'react';

import { POSSIBLE_URL_REGEX } from 'dpl/util/url';
import EmailUnavailableErrorMessage from 'dpl/components/EmailUnavailableErrorMessage';

export const CONSTRAINT_MESSAGES = {
  INVALID: 'does not appear to be a valid',
  INVALID_SIZE: 'needs at least one',
  REQUIRED_FIELD: 'required',
  TOO_LONG: 'Your response is too long (maximum is %{count} characters)',
  EMAIL_UNAVAILABLE: <EmailUnavailableErrorMessage />
};

export const CONSTRAINT_TYPES = {
  ARRAY: 'array',
  EMAIL: 'email',
  EMAIL_AVAILABLE: 'emailAvailable',
  NUMBER: 'number',
  PASSWORD: 'password',
  PRICE: 'price',
  TELEPHONE: 'telephone',
  TEXT: 'text',
  NON_EMPTY: 'nonEmpty',
  ZIP: 'zip',
  ASSOCIATION_ARRAY: 'associationArray',
  BOOLEAN: 'boolean',
  URL: 'url',
  FACEBOOK_URL: 'facebookUrl',
  INSTAGRAM_URL: 'instagramUrl',
  TERMS: 'terms',
  NON_PO_ADDRESS: 'nonPOAddress'
};

export const LARGEST_INT = 2147483647;

export const ARRAY_CONSTRAINTS = {
  truthy: true,
  array: true
};

export const EMAIL_CONSTRAINTS = {
  format: {
    pattern: /.+@.+\..+/,
    message: `${CONSTRAINT_MESSAGES.INVALID} email.`
  }
};

export const EMAIL_AVAILABLE_CONSTRAINT = {
  emailAvailable: true
};

export const NUMBER_CONSTRAINTS = {
  truthy: true,
  numericality: {
    strict: true,
    notGreaterThan: LARGEST_INT,
    message: `${CONSTRAINT_MESSAGES.INVALID} number.`
  }
};

export const PASSWORD_CONSTRAINTS = {
  truthy: true,
  length: {
    minimum: 6,
    message: 'must be at least 6 characters'
  }
};

export const PRICE_CONSTRAINTS = {
  truthy: true,
  format: {
    pattern: /^\d+(?:\.\d{0,2})$/,
    message: `${CONSTRAINT_MESSAGES.INVALID} amount.`
  }
};

export const TELEPHONE_CONSTRAINTS = {
  format: {
    pattern: /^\d{10}$/,
    message: `${CONSTRAINT_MESSAGES.INVALID} telephone number. e.g. 555-555-5555`
  }
};

export const TEXT_CONSTRAINTS = {
  truthy: true
};

export const ZIP_CONSTRAINTS = {
  format: {
    pattern: /\d{5}(-\d{4})?/,
    message: `${CONSTRAINT_MESSAGES.INVALID} zip code.`
  }
};

export const ASSOCIATION_ARRAY_CONSTRAINT = {
  associationArray: true
};

export const BOOLEAN_CONSTRAINT = {
  boolean: true
};

export const TERMS_CONSTRAINT = {
  truthy: true,
  boolean: true
};

export const FACEBOOK_URL_REGEX = /facebook\.com\/.+/i;

export const FACEBOOK_URL_CONSTRAINT = {
  optionalFormat: {
    pattern: FACEBOOK_URL_REGEX,
    message: `${CONSTRAINT_MESSAGES.INVALID} Facebook URL.`
  }
};

export const INSTAGRAM_URL_REGEX = /instagram\.com\/.+/i;

export const INSTAGRAM_URL_CONSTRAINT = {
  optionalFormat: {
    pattern: INSTAGRAM_URL_REGEX,
    message: `${CONSTRAINT_MESSAGES.INVALID} Instagram URL.`
  }
};

export const URL_CONSTRAINT = {
  format: {
    pattern: POSSIBLE_URL_REGEX,
    message: `${CONSTRAINT_MESSAGES.INVALID} URL.`
  }
};

export const NON_EMPTY_CONSTRAINT = {
  nonEmpty: true
};

export const PO_ADDRESS_REGEX = /\b(?:p\.?\s*o\.?)(\s+)?(?:box|[0-9]*)?\b/i;
export const NON_PO_ADDRESS_CONSTRAINT = {
  inverseFormat: {
    pattern: PO_ADDRESS_REGEX,
    message: 'Address cannot be a PO box. Please enter a different address or contact help@gooddog.com if you need assistance.'
  }
};

export default {
  nonEmpty: NON_EMPTY_CONSTRAINT,
  email: EMAIL_CONSTRAINTS,
  emailAvailable: EMAIL_AVAILABLE_CONSTRAINT,
  number: NUMBER_CONSTRAINTS,
  password: PASSWORD_CONSTRAINTS,
  price: PRICE_CONSTRAINTS,
  telephone: TELEPHONE_CONSTRAINTS,
  text: TEXT_CONSTRAINTS,
  zip: ZIP_CONSTRAINTS,
  associationArray: ASSOCIATION_ARRAY_CONSTRAINT,
  terms: TERMS_CONSTRAINT,
  boolean: BOOLEAN_CONSTRAINT,
  url: URL_CONSTRAINT,
  facebookUrl: FACEBOOK_URL_CONSTRAINT,
  instagramUrl: INSTAGRAM_URL_CONSTRAINT,
  nonPOAddress: NON_PO_ADDRESS_CONSTRAINT
};
